"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormField = FormField;
exports.FormRow = FormRow;
exports.FormAside = FormAside;
exports.default = Form;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Form = require("./Form.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormField(_ref) {
  var children = _ref.children;
  return _react.default.createElement("div", {
    className: (0, _Form.oForm)("field").toString()
  }, children);
}

FormField.propTypes = {
  children: _propTypes.default.node
};
FormField.defaultProps = {
  children: null
};

function FormRow(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return _react.default.createElement("div", {
    className: (0, _Form.oForm)("row").mix(className).toString()
  }, children);
}

FormRow.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
FormRow.defaultProps = {
  children: null,
  className: null
};

function FormAside(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("div", {
    className: (0, _Form.oForm)("aside").toString()
  }, _react.default.createElement("p", {
    className: (0, _Form.aFormDesc)()
  }, children));
}

FormAside.propTypes = {
  children: _propTypes.default.node
};
FormAside.defaultProps = {
  children: null
};

function Form(_ref4) {
  var children = _ref4.children,
      hasAside = _ref4.hasAside;
  return _react.default.createElement("div", {
    className: _Form.oForm.has({
      aside: hasAside
    }).toString()
  }, children);
}

Form.propTypes = {
  children: _propTypes.default.node,
  hasAside: _propTypes.default.bool
};
Form.defaultProps = {
  children: null,
  hasAside: false
};